"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const lodash_1 = require("lodash");
const constants_1 = require("../constants");
const api_1 = require("../api");
const LoadingSpinner_1 = require("../shared/LoadingSpinner");
const react_bootstrap_1 = require("react-bootstrap");
const utils_1 = require("../utils");
const FontAwesome = require("react-fontawesome");
class CustomerZipCode extends React.Component {
    constructor(props) {
        super(props);
        this.zipCode = '';
        this.state = {
            state: constants_1.ProgressState.Loading,
            customerId: '',
            customer: null,
            emptyZipCode: false,
            zipCode: ''
        };
    }
    componentWillMount() {
        // doGet(API.v1.CUSTOMERS.GET_PUBLIC(this.props.params.token)).then((response: any) => {
        this.setState({
            // customer: response.data,
            state: constants_1.ProgressState.Success
        });
        // }).catch(error => {
        //     this.setState({
        //         state: ProgressState.Failed
        //     })
        // });
    }
    render() {
        let content;
        switch (this.state.state) {
            case constants_1.ProgressState.Loading:
                content = React.createElement(LoadingSpinner_1.default, { key: "CustomerZipCodeLoadingSpinner" });
                break;
            case constants_1.ProgressState.Success:
                content = this.renderSocialInfo();
                break;
            case constants_1.ProgressState.None:
                lodash_1.delay(() => this.setState({ state: constants_1.ProgressState.Success }), 10);
                break;
            default:
                break;
        }
        return React.createElement("div", null, content);
    }
    componentDidUpdate() {
        $('[data-toggle="popover"]').popover({
            trigger: 'focus'
        });
    }
    saveZipCode() {
        return __awaiter(this, void 0, void 0, function* () {
            //TODO: check 5 digit numbers ( errMessage: "Please enter a valid 5 digit number for the zip code." modal popup error )
            if (this.zipCode === '') {
                return this.setState({ emptyZipCode: true });
            }
            api_1.doPost(api_1.API.v1.CUSTOMERS.SAVE_ZIP_CODE(this.props.params.token), { zipCode: this.zipCode }).then(data => {
                //TODO: show green beautiful alert
                this.zipCode = '';
                alert('ok');
                this.forceUpdate();
            }).catch(error => {
                console.log('error', error);
            });
        });
    }
    renderSocialInfo() {
        return React.createElement("div", { className: `` }, React.createElement("div", { className: `zc_temp_header` }, "LoyalReach"), React.createElement("div", { className: `flex-center zc_cont` }, React.createElement(react_bootstrap_1.Col, { xs: 12, sm: 6, lg: 6 }, React.createElement("div", { className: `zc_main_title` }, "Welcome to your Community Watch \uD83D\uDC40"), React.createElement("div", { className: `zc_s_title` }, "We\u2019re excited to have you here!"), React.createElement("ul", { className: `zc_list` }, React.createElement("li", null, "Here\u2019s what you can do:"), React.createElement("li", null, "\uD83D\uDCAC Two-Way Communication"), React.createElement("li", null, "\uD83E\uDD1D Share any alerts and notifications."), React.createElement("li", null, "\uD83D\uDD25 Incident report"), React.createElement("li", null, "\uD83D\uDD75 Anonymous tips"), React.createElement("li", null, "\uD83D\uDCE2 Be part of meaningful discussions")), React.createElement("ul", { className: `zc_list` }, React.createElement("li", null, "To keep things lively and inclusive for everyone:"), React.createElement("li", null, "\u2705 Be respectful"), React.createElement("li", null, "\u2705 Stay on topic"), React.createElement("li", null, "\u2705 Follow our community guidelines")), React.createElement("div", { className: `zc_make` }, "Let\u2019s make this space awesome together! \uD83D\uDE80"), React.createElement(react_bootstrap_1.Col, { xs: 12, lg: 4, md: 4, className: `center-all` }, React.createElement(react_bootstrap_1.FormControl, { name: "zipCode", type: "text", placeholder: "Enter Your zip code", onChange: event => utils_1.FormUtils.dataChanged(event, this) })), React.createElement(react_bootstrap_1.Col, { xs: 12, lg: 5, md: 5 }, React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", title: "Continue", onClick: () => this.saveZipCode(), "data-cy": "add_business_btn" }, this.state.state === constants_1.ProgressState.Loading && React.createElement(FontAwesome, { name: "spinner", spin: true, fixedWidth: true }), this.state.state !== constants_1.ProgressState.Loading && "Continue")), this.state.emptyZipCode && React.createElement(react_bootstrap_1.Col, { xs: 12, lg: 12, md: 12, className: `error-message` }, "Require field*"))), React.createElement(react_bootstrap_1.Col, { className: `zc_f_m`, xs: 12, lg: 12, md: 12 }, React.createElement("div", { className: `zc_f_1` }, "Courtesy of loyalreach.com"), React.createElement("div", { className: `zc_f_2` }, "For any emergency, please contact your local emergency response service.")));
    }
}
exports.default = CustomerZipCode;


//////////////////
// WEBPACK FOOTER
// ./client/src/layout/CustomerZipCode.tsx
// module id = 1362
// module chunks = 1 2